import type {Suggestions} from '@github-ui/inline-autocomplete/types'
import {useQuery} from '@github-ui/react-query'
import {useMemo} from 'react'

import {useChatManager} from '../../utils/CopilotChatManagerContext'
import {DiscussionSuggestion} from './DiscussionSuggestion'

export interface DiscussionsQuery {
  category: 'discussions'
  filter: string
  repository: string
}

export function useDiscussionsSuggestions(query: DiscussionsQuery | null) {
  const {service} = useChatManager()

  const discussionsQuery = useQuery({
    enabled: query !== null,
    queryKey: ['copilot-autocomplete-discussions', query?.repository, query?.filter],
    queryFn: async () => service.fetchAutocompleteDiscussions(query!.repository, query!.filter),
  })

  return useMemo<Suggestions | null>(() => {
    if (!query) return null

    if (discussionsQuery.isLoading) return 'loading'

    return (
      discussionsQuery.data?.map(discussion => ({
        value: `${query.repository}/discussions/${discussion.number}`,
        key: discussion.number.toString(),
        render: props => <DiscussionSuggestion {...props} discussion={discussion} />,
      })) ?? null
    )
  }, [discussionsQuery.data, discussionsQuery.isLoading, query])
}
